import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import SalesDashboard from './pages/SalesDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ManagerDashboard from './pages/ManagerDashboard';
import InstallerDashboard from './pages/InstallerDashboard';
import { Toaster } from 'sonner';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configure axios defaults for cross-domain cookies
axios.defaults.withCredentials = true;

export { API };

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Set Authorization header from localStorage if available
    const token = localStorage.getItem('auth_token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    checkAuth();
  }, []);

  const checkAuth = async (userData = null) => {
    // If user data is provided directly (from login), use it
    if (userData) {
      setUser(userData);
      setLoading(false);
      return;
    }
    
    // Otherwise, fetch from backend
    try {
      const response = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(response.data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      localStorage.removeItem('auth_token');
      delete axios.defaults.headers.common['Authorization'];
      setUser(null);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!user ? <Login onLogin={checkAuth} /> : <Navigate to={user.role === 'admin' ? '/admin' : user.role === 'manager' ? '/manager' : user.role === 'installer' ? '/installer' : '/app'} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/app/*" element={user && user.role === 'sales' ? <SalesDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/admin/*" element={user && user.role === 'admin' ? <AdminDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/manager/*" element={user && user.role === 'manager' ? <ManagerDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/installer/*" element={user && user.role === 'installer' ? <InstallerDashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/" element={<Navigate to={user ? (user.role === 'admin' ? '/admin' : user.role === 'manager' ? '/manager' : user.role === 'installer' ? '/installer' : '/app') : '/login'} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
